<template>
  <div class="howItWorksStepperMobileContainer w-100 flex-col-start-center">
    <div id="howItWorksStepList" class="stepList flex-1 flex-col-center">
      <template
        v-for="i in dotCount"
      >
        <button
          :id="`mobile-${i}-step-button`"
          :key="`${i}-button`"
          class="btnDot p-0 no-scale flex-center"
          :data-testid="`how-it-works-${i}-step-button`"
          @click="activeDot = i"
        >
          <div class="dot" :class="dotClass(i)"></div>
        </button>
        <BPopover
          :key="`${i}-popover`"
          container="#howItWorksStepList"
          :custom-class="`stepPopoverMobile ${dotClass(i)}`"
          :disabled="true"
          :no-fade="true"
          placement="right"
          :show="true"
          :target="`mobile-${i}-step-button`"
        >
          <button class="text-left" @click="activeDot = i">
            <HowItWorksPopoverContents :index="i" />
          </button>
        </BPopover>
        <div v-if="i !== dotCount" :key="`${i}-line`" class="line flex-1" :class="dotClass(i)" />
      </template>
    </div>
  </div>
</template>

<script>
import { baseStepper } from '../mixins/baseStepper';

export default {
  name: 'HowItWorksStepperMobile',
  mixins: [baseStepper]
};
</script>

<style lang="scss">
@import '@sass/vue-imports.scss';

.stepPopoverMobile {
  background: $brand-dark;
  border: 2px solid $corduroy;
  border-radius: 5px;
  max-width: 67vw;
  z-index: 1029;

  @media (max-width: 390px) {
    max-width: 60vw;
  }

  &.active {
    border-color: $primary;

    .popover-body {
      color: #FFF;
    }

    > .arrow {
      &:before {
        border-right-color: $primary;
      }
      &:after {
        border-right-color: $brand-dark;
      }
    }
  }

  .popover-body {
    color: $corduroy;
  }

  > .arrow {
    &:before {
      border-right-color: $corduroy;
    }
    &:after {
      left: 2px;
      border-right-color: $brand-dark;
    }
  }
}

.howItWorksStepperMobileContainer {
  .stepList {
    min-height: 650px;
    margin-top: 50px;
    margin-bottom: 50px;
  }

  .line {
    background: #FFF;
    transition: all .3s ease-in-out;
    width: 2px;

    &.dulled {
      background: $corduroy;
    }

    &.active {
      background: linear-gradient(0deg, $corduroy 38.6%, $primary 100%);
    }
  }

  .btnDot {
    position: relative;
    width: 54px;
    background: $brand-dark;
    height: 54px;

    &:hover {
      .dot {
        width: 24px;
        height: 24px;
      }
      >span {
        bottom: -26px;
      }
    }

    .dot {
      border-radius: 50%;
      width: 16px;
      height: 16px;
      background: #FFF;
      transition: all .3s ease-in-out;

      &.dulled {
        background: $corduroy;
      }

      &.active {
        width: 24px;
        height: 24px;
        background: $primary;
      }
    }

    >span {
      color: #FFF;
      position: absolute;
      bottom: -30px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 12px;
      white-space: nowrap;
      transition: all .3s ease-in-out;
      &.active {
        bottom: -26px;
      }
    }
  }
}
</style>